module.exports = __webpack_public_path__ + "static/media/Buvidal_Monthly_CMI.ef3ec4ab.pdf";